import React from "react";
import useTheme from "@material-ui/core/styles/useTheme";

export default ({ color }) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.dark;
  }

  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 32 32"
      xmlSpace="preserve"
    >
      <rect
        fill={color}
        id="Rectangle_6539"
        x="14.4"
        y="17.25"
        className="st0"
        width="1.77"
        height="1.78"
      />
      <rect x="4.99" y="2.87" fill="none" width="22" height="27" />
      <g id="Group_7063">
        <path
          id="Path_8127"
          fill={color}
          d="M18.91,2.65H8.14C6.66,2.65,5.46,3.86,5.46,5.34L5.45,26.88c0,1.48,1.2,2.69,2.68,2.69H24.3
		c1.48,0,2.69-1.21,2.69-2.69V10.73L18.91,2.65z M17.57,4.67l7.4,7.4h-7.4V4.67z M10.85,22.58H7.3V20.8h1.77v-5.32h1.77V22.58z
		 M17.95,19.03v1.77H14.4v1.78h-1.77v-7.1h5.32V19.03z M25.05,17.25H21.5v3.55h1.78v-1.77h1.77v3.55h-5.32v-7.1h5.32V17.25z"
        />
      </g>
    </svg>
  );
};
